
  import { mapState } from 'vuex'
  import dataTable from '~/mixins/dataTable'
  export default {
    name: 'Theme2MissionDesktopRewardHistoryPage',
    mixins: [dataTable],
    data() {
      return {
        api: 'activities/exchange-reward/getRewardHistories',
        previousSelectedStatus: []
      }
    },
    computed: {
      ...mapState({
        rewardHistories: state => state.activities['exchange-reward'].rewardHistories
      }),
      headers() {
        return [
          {
            text: this.tl('requestTime'),
            value: 'created_at'
          },
          {
            text: this.tl('claimTime'),
            value: 'claim_date'
          },
          {
            text: this.tl('type'),
            value: 'reward_type'
          },
          {
            text: this.tl('rewardName'),
            value: 'reward_name',
            sortable: false
          },
          {
            text: this.tl('quantity'),
            value: 'quantity'
          },
          {
            text: this.tl('totalCredit'),
            value: 'exchange_value'
          },
          {
            text: this.tl('totalCoins'),
            value: 'exchange_coins'
          },
          {
            text: this.tl('status'),
            value: 'status'
          }
        ]
      },
      statusList() {
        return [
          {
            text: this.tl('pending'),
            value: 1
          },
          {
            text: this.tl('success'),
            value: 2
          },
          {
            text: this.tl('rejected'),
            value: 3
          }
        ]
      }
    },
    mounted() {
      this.customFilters = {
        start_date: this.$dayjs().startOf('year').format('YYYY-MM-DD 00:00:00'),
        end_date: this.$dayjs().format('YYYY-MM-DD 23:59:59')
      }
      // this.API()
    },
    methods: {
      sumField(data, key) {
        if (data?.data?.length > 0) {
          return data.data.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0)
        } else {
          return 0
        }
      },
      onChangeStartDate(date) {
        this.customFilters.start_date = date
        if (this.options.page === 1) {
          this.API()
        } else {
          this.options.page = 1
        }
        // this.API()
      },
      onChangeEndDate(date) {
        this.customFilters.end_date = date
        if (this.options.page === 1) {
          this.API()
        } else {
          this.options.page = 1
        }
        // this.API()
      },
      findNewElements(a, b) {
        return b.filter(item => !a.includes(item))
      },
      onStatusChange() {
        // this.API()
        if (this.options.page === 1) {
          this.API()
        } else {
          this.options.page = 1
        }
      }
    }
  }
